//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    var $el = this;
    var date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth();
    var firstDay = new Date(y, m, 1);
    var lastDay = new Date(y, m + 1, 0);
    return {
      loading: true,
      headers: [],
      residents: [],
      fields: [],
      items: [],
      start_date: firstDay,
      end_date: lastDay
    };
  },

  props: ['reportId', 'reportType', 'reportTable'],
  mounted: function mounted() {
    var $el = this;
    this.getReport();
  },

  methods: {
    timeRangeChange: function timeRangeChange(_ref) {
      var start_date = _ref.start_date,
          end_date = _ref.end_date;

      this.start_date = start_date.toDate();
      this.end_date = end_date.toDate();
      this.getReport();
    },
    getReport: function getReport() {
      var $el = this;
      axios.post('/prototype/reporting/get-report', {
        type: $el.reportId,
        table: $el.reportTable,
        start_date: this.start_date,
        end_date: this.end_date
      }).then(function (response) {
        if (response.data) {
          $el.headers = response.data.header;
          $el.fields = response.data.field;
          $el.residents = response.data.result;
          $el.loading = false;
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    exportReport: function exportReport() {
      Event.$emit('export-report', {
        type: this.reportId,
        table: this.reportTable,
        start_date: this.start_date,
        end_date: this.end_date
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/reports/MoveInsByMonth.vue
// module id = 2Vm9
// module chunks = 0 1